import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-exchange",
  "use": "icon-exchange-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-exchange\"><path d=\"M896 128v335.616h-3.008v0.384h-99.328l-0.064-0.384H557.632l156.16-154.816a288 288 0 1 0 67.456 299.264L883.84 608a384 384 0 1 1-100.8-368L896 128z\" p-id=\"10382\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol